import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "./app";
import api from "./api";
import API_URL from "../config/ApiUrl";

const CompanyManagementSlice = createSlice({
  name: "CompanyManagement",
  initialState: {},
  reducers: {},
});
export const getCompanyManagementList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const resp = await api.post(API_URL.COMPANY_MENAGEMENT.LIST, payload);
      return Promise.resolve(resp.data);
    } catch (e: any) {
      return Promise.reject(e.data);
    }
  };
export const CompanyDetails =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const resp = await api.post(API_URL.COMPANY_MENAGEMENT.DETAILS, payload);
      return Promise.resolve(resp.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export const FixBulkCSV =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(
        API_URL.COMPANY_MENAGEMENT.FIX_CSV_INSERT,
        payload
      );
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export const deleteCompanyData =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(
        API_URL.COMPANY_MENAGEMENT.DELETE,
        payload
      );
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export const exportFormFields =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.get(API_URL.COMPANY_MENAGEMENT.EXPORT);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export const exportList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const resp = await api.post(
        API_URL.COMPANY_MENAGEMENT.EXPORT_DATA,
        payload
      );
      return Promise.resolve(resp.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export default CompanyManagementSlice.reducer;
